import { Table } from 'react-bootstrap';
import { IManagingWindowsServiceInstance } from '../../api/models';
import { Checkbox } from '../../areas/app/Checkbox';
import { WindowsServiceAction } from '../../constants/WindowsServiceAction';
import { WindowsServiceStartType } from '../../constants/WindowsServiceStartType';
import { ScopedUserPrincipal } from '../../permissions/ScopedUserPrincipal';
import { UserPrincipal } from '../../permissions/userPrincipal';
import { ServerApplicationClientEventSummary } from '../../signalr/models';
import { EmptyDataRow } from '../UIExtentions/TableUtilities';
import { WindowsServiceActionHandlerProps } from './WindowsServicesServerManagementView';
import { WindowsServicesServerRow } from './WindowsServicesServerRow';

interface WindowsServicesServerTableProps {
    userPrincipal: UserPrincipal;
    serversUserPrincipal: ScopedUserPrincipal;
    allServersSelectionChanged: (selected: boolean) => void;
    serverSelectionChanged: (selected: boolean, serverName: string) => void;
    onClickCallback: (props: WindowsServiceActionHandlerProps) => Promise<void>;
    serverApps: IManagingWindowsServiceInstance[];
    servers: string[];
    allSelected: boolean;
    onTimeoutCallback: (data: ServerApplicationClientEventSummary) => void;
}
export const WindowsServicesServerTable = ({
    userPrincipal,
    serversUserPrincipal,
    allServersSelectionChanged,
    serverSelectionChanged,
    onClickCallback,
    serverApps,
    servers,
    allSelected,
    onTimeoutCallback,
}: WindowsServicesServerTableProps) => {
    return (
        <Table striped size="sm">
            <thead>
                <tr>
                    <th scope="col" className="col-1">
                        <Checkbox selected={allSelected} selectionChangedCallback={allServersSelectionChanged} />
                    </th>
                    <th scope="col" className="col-4">
                        Name
                    </th>
                    <th scope="col" className="col-1">
                        Env.
                    </th>
                    <th scope="col" className="col-1">
                        Startup
                    </th>
                    <th scope="col" className="col-1">
                        Status
                    </th>
                    <th scope="col" className="col-0">
                        Refresh
                    </th>
                    <th scope="col" className="col-4">
                        Actions
                    </th>
                </tr>
            </thead>
            <tbody>
                {serverApps !== null && serverApps.length > 0 ? (
                    serverApps.map(function (serverApp: IManagingWindowsServiceInstance) {
                        const selected = servers.includes(serverApp.serverName);
                        return (
                            <WindowsServicesServerRow
                                serverApp={serverApp}
                                key={serverApp.serverId}
                                selected={selected}
                                userPrincipal={userPrincipal}
                                serverUserPrincipal={serversUserPrincipal?.getUserPrincipal(serverApp.serverName)}
                                selectionChangedCallback={serverSelectionChanged}
                                onClickCallback={async (action: WindowsServiceAction, startType?: WindowsServiceStartType) =>
                                    await onClickCallback({
                                        serviceName: serverApp.name,
                                        servers: [serverApp.serverName],
                                        action: action,
                                        startType: startType,
                                    })
                                }
                                onTimeoutCallback={onTimeoutCallback}
                            />
                        );
                    })
                ) : (
                    <EmptyDataRow colSpan={7} />
                )}
            </tbody>
        </Table>
    );
};
